import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { ContaService } from '../../../../shared/services/conta/conta.service';
import { CriarSenhaService } from '../../../../shared/services/auth/criar-senha/criar-senha.service';

import * as md5 from 'blueimp-md5';

declare var $: any;

@Component({
  selector: 'app-criar-senha',
  templateUrl: './criar-senha.component.html',
  styleUrls: ['./criar-senha.component.scss']
})
export class CriarSenhaComponent implements OnInit {
  public form: FormGroup;
  public id: string;
  public conta: any = null;
  public email: string;
  public code: string;
  public nome: string;
  public senhaType = false;
  public apiError = '';
  public success = false;
  public confirmaSenhaType = false;
  public responseMessage = '';

  constructor(
    private criarSenhaService: CriarSenhaService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private elRef: ElementRef,
    private contaService: ContaService,
  ) { }

  ngOnInit() {
    if (this.route.snapshot.params['id']) {
      this.id = this.route.snapshot.params['id'];
    }

    if (this.route.snapshot.params['code']) {
      this.code = this.route.snapshot.params['code'];
    }

    this.form = this.fb.group({
      senha: [null, [Validators.required]],
      confirmaSenha: [null, [Validators.required]]
    }, { validator: this.matchPassword });
  }

  matchPassword(AC: AbstractControl) {
    const senha = AC.get('senha').value;
    const confirmaSenha = AC.get('confirmaSenha').value;
    if (senha !== confirmaSenha) {
      AC.get('confirmaSenha').setErrors( { MatchPassword: true } );
    } else {
      return null;
    }
  }

  keyUpSenha() {
    this.senhaType = true;
  }

  keyUpConfirmaSenha() {
    this.confirmaSenhaType = true;
  }

  showErrors() {
    this.senhaType = true;
    this.confirmaSenhaType = true;
  }

  submit() {
    this.enableLoading();
    this.success = false;

    const objSenha = {
      Id: this.id,
      NovaSenha: md5(this.email + this.form.controls['senha'].value),
      NovaSenhaConfirmacao: md5(this.email + this.form.controls['confirmaSenha'].value),
      Codigo: this.code
    };

    this.criarSenhaService.criarSenha(objSenha)
    .subscribe(() => {
      this.disableLoading();
      this.success = true;
      this.responseMessage = 'A sua senha foi criada com sucesso!';
    }, (err) => {
      this.success = false;

      if (err && err.error && err.error.errors && err.error.errors.DomainValidations && err.error.errors.DomainValidations.length > 0) {
        this.responseMessage = err.error.errors.DomainValidations[0];
      } else if (err && err.error && err.error.ModelState && err.error.ModelState.Erros && err.error.ModelState.Erros.length > 0) {
        this.apiError = err.error.ModelState.Erros[0];
      } else {
        this.apiError = 'Não foi possível criar a senha. Tente novamente mais tarde.';
      }

      this.disableLoading();
    });
  }

  enableLoading() {
    $(this.elRef.nativeElement).find('.btn-registrar').addClass('loading');
  }

  disableLoading() {
    $(this.elRef.nativeElement).find('.btn-registrar').removeClass('loading');
  }
}
